import React, { useEffect, useState } from 'react'
import profileBanner from '../../Assets/images/profile-bnr.webp'
import { useLocation, useParams } from 'react-router-dom'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import FrontLoader from '../layout/FrontLoader'
import { getFromStorage } from '../../utils/Helper'

function Cms() {
  const { id } = useParams()
  const CMS = useMakeRequest()
    const path_name = useLocation()
  const [data, setData] = useState<any>({})
  const path = path_name?.pathname.split('/')
  const Lang = getFromStorage({key: "Translate"})

  useEffect(() => {
    const payload = {
      "slug": path[2],
      "user_type": 1,
      lang_id:Lang == "spa" ? "2" : '1'
    }
    CMS.makeRequest({ payload, url: ApiConstants?.Cms, toastStatus: false })
  }, [id])
  useEffect(() => {
    if (CMS?.status) {
      setData(CMS?.data?.data)
    }
  }, [CMS?.status])

  return (
    <>
    {CMS?.loading  ? <FrontLoader/> : null}

      <main>
        <div className='content-height'> 
          <section className="main-banner small-banner" style={{ background: `url(${profileBanner}) center/cover` }}>
            <div className="container">
              <h1 className="small-banner-heading">{data?.cms_pages_details?.title}</h1>
            </div>
          </section>
          <div className="container footer-space cms-content">

            <h2 className="title-1 mt-4 mb-2">{data?.cms_pages_details?.title}</h2>
            <p
              className="com-para"
              dangerouslySetInnerHTML={{ __html: data?.cms_pages_details?.content }}
            ></p>
          </div>
        </div>

      </main>

    </>
  )
}

export default Cms